// Connected Words — 1e Editie / 1st Edition
// 6 woorden × 100 stuks per woord
// Elk shirt: voorkant = woord, achterkant = unieke QR + serie (formaat: E1-42/100)
//
// Sectiestructuur volgt de "Connected_Words_Mindmap_Exact_Hierarchy":
//   01 LIMITED · 02 UNIQUE · 03 YOUR STORY · 04 LIVING ·
//   05 CONNECTED · 06 PHYSICAL PRODUCT · 07 LAUNCH/FOMO · 08 THE MAGIC BEHIND IT

// Image optimisation helper — proxies large PNGs through wsrv.nl (Cloudflare-backed
// free image CDN) to resize + convert to WebP. Also normalises URL encoding, which
// helps mobile Safari with paths containing spaces (%20).
const optim = (url, w = 900) => {
  const clean = url.replace(/^https?:\/\//, "");
  return `https://wsrv.nl/?url=${encodeURIComponent(clean)}&w=${w}&output=webp&q=82`;
};

// Persona demo QR images (Danny / Mia / Vera) — proxied to solve iOS Safari load issues.
// These are the "demo-" versions that never conflict with real 1iD user data.
const PERSONA_QRS = {
  danny: optim(
    "https://customer-assets.emergentagent.com/job_word-shirt-qr-1/artifacts/m0qc1z3p_demo-QR1.png",
    500,
  ),
  mia: optim(
    "https://customer-assets.emergentagent.com/job_word-shirt-qr-1/artifacts/9h349d49_demo-QR2.png",
    500,
  ),
  vera: optim(
    "https://customer-assets.emergentagent.com/job_word-shirt-qr-1/artifacts/mivrt9pq_demo-QR3.png",
    500,
  ),
};

export const translations = {
  nl: {
    nav: {
      limited: "LIMITED",
      unique: "UNIQUE",
      story: "YOUR STORY",
      connected: "CONNECTED",
      launch: "1e EDITIE",
      magic: "1iD",
    },
    cta: {
      reserveTop: "BESTEL NÚ VIA 1iD",
      reserveHero: "BESTEL NÚ VIA 1iD",
      readConcept: "LEES HET CONCEPT",
      reserveOn1iD: "Bestel nú via 1iD",
    },
    breadcrumb: {
      edition: "1e EDITIE",
      title: "CONNECTED WORDS",
      drop: "6 × 100",
      live: "LIVE",
    },
    sideLabel: "6 WOORDEN · GELIMITEERD OP 100 STUKS VAN ELK WOORD",
    editionLabel: "1e Editie",
    // Marketing popup — HTML/CSS, volledig NL/EN
    preorder: {
      eyebrow: "1e EDITIE · LANCERING 01 SEP 2026",
      title: "Geen shirt.",
      titleAccent: "Een levende identiteit.",
      lines: [
        "6 woorden. 600 shirts. Nooit meer bijgedrukt.",
        "Elk shirt draagt een uniek nummer én een unieke QR.",
        "Jij beslist wat de wereld ziet wanneer iemand scant.",
      ],
      metaLeft: "1st EDITION",
      metaRight: "6 × 100",
      cta: "BESTEL NÚ VIA 1iD",
      note: "Registratie, checkout, betaling en QR-personalisatie verlopen volledig binnen 1iD.",
      close: "Sluiten",
      // Tijdelijke voucher-variant (actief tot 30-sep-2026 EOD)
      discountLines: [
        "Claim jouw voucher van 30% discount via onderstaande link.",
        "De voucher is beperkt in tijd en aantal dus wees snel.",
      ],
      discountCta: "CLAIM SNEL JOUW VOUCHER",
      discountUrl:
        "https://use1id-prd.vercel.app/r/logon?discount_grant_token=c5e8e2ca-5e2f-45c9-a506-42b43ca804fe&next=%2Fr%2FMy-1iD-Products%3Fdiscount_grant_token%3Dc5e8e2ca-5e2f-45c9-a506-42b43ca804fe",
    },
    // Launch event popup — actief tot 5 sept 2026 10:00 CET
    launchEvent: {
      eyebrow: "5 SEP 2026 · TIENEN",
      title: "Win jouw",
      titleAccent: "Connected Words T-shirt",
      when: "Zaterdag 5 september · 10:10 – 12:10 · Tienen",
      intro:
        "De 1st Limited Edition van Connected Words wordt gelanceerd. Zoek de zes woorden, connecteer met de deelnemende Tiense handelaars en verzamel punten.",
      sentence: "TOGETHER · WE · TURN · WORDS · INTO · MEANING",
      journey: "ZOEK → SCAN → ANTWOORD → VERZAMEL",
      mechanic:
        "Hoe meer punten, hoe groter je korting — tot 100 punten = gratis T-shirt.",
      warningLabel: "LET OP",
      warning:
        "Slechts 6 kortingsbonnen kunnen verzilverd worden. De eerste 6 aankopers winnen. Een hoge score alleen is dus niet genoeg — snelheid van verzilveren telt mee.",
      howLabel: "HOE WERKT HET?",
      how: [
        'Vóór aanvang wordt de knop "CW Launch Page" actief (voorlopig inactief).',
        'Om 10:10 wordt "Start Journey" actief — klik, en de wedstrijd start.',
        "De opdrachten leiden je stap voor stap langs de handelaars en vragen.",
        "Waar je precies uitkomt? Dat ontdek je pas onderweg.",
        "Om 12:10 sluit de wedstrijd.",
      ],
      prepareLabel: "BEREID JE VOOR",
      prepare: [
        "Maak vooraf je gratis 1iD-account aan.",
        "Test of je QR-scanner probleemloos werkt — probeer het uit op de 3 demo-codes op deze website.",
        "Volg de Connected Words website, Facebook en Instagram voor de link.",
      ],
      uniqueLabel: "WAT MAAKT DIT SHIRT UNIEK?",
      unique:
        "Elk T-shirt uit de 1st Limited Edition is certified, limited, unique: eigen woord, uniek nummer, unieke QR-code, eigen eigenaar. Via 1iD bepaal jij zelf wat verschijnt wanneer iemand jouw code scant — en je past het later gewoon aan.",
      taglineLine1: "JOUW SHIRT. JOUW QR-CODE. JOUW VERHAAL.",
      taglineLine2: "TOGETHER WE TURN WORDS INTO MEANING.",
      launchBtn: "CW LAUNCH PAGE",
      launchBtnDisabledHint: "(voorlopig inactief)",
      registerBtn: "SPEEL MEE VIA DEZE LINK",
      registerUrl: "https://use1id-prd.vercel.app/r/register?next=",
      close: "Sluiten",
    },
    // End-to-end marketing showcase (embedded onderaan)
    showcase: {
      eyebrow: "NIET ZOMAAR EEN T-SHIRT.",
      title: "Een unieke 1iD.",
      titleAccent: "Een levende identiteit.",
      sub: "SCAN. CONNECT. VOLG. CONFIGUREER.",
      tagline: "WOORDEN VERBINDEN. IDENTITEIT BLIJFT.",
      steps: [
        {
          index: "01",
          title: "GEMAAKT OM UNIEK TE ZIJN",
          body: "Elk shirt maakt deel uit van een gelimiteerde editie. Slechts 100 stuks per woord — wereldwijd.",
        },
        {
          index: "02",
          title: "SCAN OM TE VERBINDEN",
          body: "Directe toegang tot een levende, digitale identiteit — die van de eigenaar.",
        },
        {
          index: "03",
          title: "CONFIGUREER & BEHEER",
          body: "Jij hebt de controle. Altijd. Pas aan wat de wereld ziet — wanneer jij wil.",
        },
      ],
      manageActions: [
        "Werk inhoud bij",
        "Voeg items toe",
        "Beheer zichtbaarheid",
        "Regel wat je deelt",
        "Jij beslist wat wie ziet",
      ],
      pillars: [
        { label: "IDENTITY", body: "Jouw digitale identiteit — in één scan." },
        { label: "AUTHENTICITY", body: "100% geverifieerd. 100% uniek." },
        { label: "CONNECTION", body: "Verbind met mensen, projecten & bedoeling." },
        { label: "STORY", body: "Deel jouw verhaal. Op jouw manier." },
        { label: "LEGACY", body: "Vandaag een collectible. Voor altijd een verhaal." },
        { label: "PRIVACY FIRST", body: "Jij houdt altijd de controle." },
      ],
      cta: "BESTEL NÚ VIA 1iD",
      profileCard: {
        badge: "BUSINESS · IDENTITY CARD",
        name: "Danny Vandijck",
        role: "Founder · Business Optimization, Coach, Change Manager",
        message: "Beschikbaar voor projecten vanaf 01-SEP-2026. Bereik me via mijn website.",
        links: ["Website · dv-mc.com", "LinkedIn · dannyvandijck", "Instagram · use1id", "Connected Words shop"],
        footer: "QR profile powered by 1iD · Your product. Your identity.",
      },
    },
    hero: {
      eyebrow: "MORE THAN JUST A T-SHIRT",
      headlineParts: ["Together", " we ", "turn", " words ", "into meaning."],
      sub: "Jouw shirt. Jouw QR-code. Jouw verhaal.",
      intro:
        "Zes woorden. Slechts 100 unieke shirts per woord. Geen herdruk, geen tweede oplage. Elk shirt draagt een unieke QR-code die jij zelf beheert via 1iD.",
      stats: {
        edition: "Editie",
        editionValue: "E1",
        words: "Woorden",
        wordsValue: "6 × 100",
        reprint: "Herdruk",
        reprintValue: "Nooit",
      },
    },
    // 01 · LIMITED — 1e Editie · 6 woorden · 100 per woord · geen herdruk
    limited: {
      number: "01 / LIMITED",
      eyebrow: "1e EDITIE · 6 × 100",
      title: "Een gelimiteerde eerste editie. Geen tweede kans.",
      body:
        "6 woorden. 100 shirts per woord. 600 stuks in totaal. Wanneer een woord uitverkocht is, is het weg. 1e Editie blijft 1e Editie — er komt geen herdruk, geen alternatieve oplage. Wie te laat is, mist het.",
      stats: [
        { label: "Editie", value: "E1" },
        { label: "Woorden", value: "6" },
        { label: "Per woord", value: "100" },
        { label: "Herdruk", value: "Nooit" },
      ],
      whyItMatters: "WAAROM DIT ER TOE DOET",
      reasons: [
        "Als een woord uitverkocht is, is het definitief weg.",
        "Editie 1 blijft Editie 1 — geen herdruk.",
        "Je bezit een specifiek exemplaar van de editie.",
      ],
    },
    // 01b · De collectie — tegels per woord
    collection: {
      number: "01 · DE COLLECTIE",
      title: "Zes woorden. Zes werelden. 100 unieke eigenaars per woord.",
      hint: "Hover of tik om de betekenis te lezen. Elk woord bestaat slechts 100 keer.",
    },
    // 02 · UNIQUE — jouw nummer, jouw QR, jouw profiel + authenticiteit
    unique: {
      number: "02 / UNIQUE",
      title: "Jouw nummer. Jouw QR. Jouw profiel.",
      body:
        "Elk shirt is individueel genummerd (1/100 → 100/100) en heeft zijn eigen QR-code. De QR is geen vaste link — hij is verbonden met een profiel dat jij zelf kiest en aanpast. Jouw exemplaar bestaat maar één keer.",
      pillars: [
        {
          label: "JOUW NUMMER",
          items: [
            "Elk shirt individueel genummerd",
            "1/100 → 100/100",
            "vb: E1 · TOGETHER · 017/100",
            "Jouw exemplaar bestaat slechts één keer",
          ],
        },
        {
          label: "JOUW QR",
          items: [
            "Elk shirt heeft een eigen QR",
            "Scan het shirt",
            "QR verbindt het fysieke shirt met de digitale ervaring",
            "Geen vaste link — een levende identiteit",
          ],
        },
        {
          label: "JOUW PROFIEL",
          items: [
            "Jij kiest het QR Profiel",
            "Configureer wat je deelt",
            "Verander wat de wereld ziet",
            "Privacy first — jij blijft in controle",
          ],
        },
      ],
      authenticityLabel: "AUTHENTICITEIT",
      authenticity: [
        "Unieke productidentiteit",
        "Certificate of Authenticity",
        "Editie · Woord · Uniek nummer",
        "QR gekoppeld aan dit exacte shirt",
      ],
    },
    // 03 · YOUR STORY — wat kan jouw shirt onthullen?
    story: {
      number: "03 / YOUR STORY",
      eyebrow: "WHAT CAN YOUR SHIRT REVEAL?",
      title: "Wat kan jouw shirt onthullen?",
      body:
        "Business. Muziek. Sport. Social. Events. Shop. Jij. Zij scannen. Jij beslist wat ze ontdekken.",
      categories: [
        {
          key: "BUSINESS",
          items: ["Business card", "Bedrijf", "Website", "LinkedIn", "Portfolio / CV", "Contact"],
        },
        {
          key: "MUSIC",
          items: ["Artist / band-profiel", "Spotify", "Songs", "Optredens", "Volgende data", "Muziek-verhaal"],
        },
        {
          key: "SPORT",
          items: ["Atleten-profiel", "Club", "Resultaten", "Palmares", "Sponsors", "Volgende events"],
        },
        {
          key: "SOCIAL / CREATOR",
          items: ["TikTok", "Instagram", "Social profielen", "Laatste content", "Samenwerkingen"],
        },
        {
          key: "EVENTS",
          items: ["Event-info", "Data", "Locatie", "Programma", "Special experience / game / clue"],
        },
        {
          key: "SHOP",
          items: ["Webshop", "Producten", "Nieuwe releases", "Aanbiedingen"],
        },
        {
          key: "YOU",
          items: ["Persoonlijke boodschap", "Foto's", "Herinneringen", "Interesses", "Projecten", "Alles wat jou raakt"],
        },
      ],
      coreLine1: "ZIJ SCANNEN.",
      coreLine2: "JIJ BESLIST WAT ZE ONTDEKKEN.",
    },
    // 04 · LIVING — hetzelfde shirt, nieuw verhaal + overdraagbaarheid
    living: {
      number: "04 / LIVING",
      eyebrow: "SAME SHIRT. NEW STORY.",
      title: "Hetzelfde shirt. Een nieuw verhaal.",
      body:
        "Je leven verandert. Je interesses veranderen. Je werk verandert. Je events veranderen. Je content verandert. Jouw QR Profiel kan mee veranderen.",
      pivots: [
        { label: "VANDAAG", body: "Business-profiel" },
        { label: "VANAVOND", body: "Muziek- of event-profiel" },
        { label: "MORGEN", body: "Iets compleet anders" },
      ],
      coreIdea: [
        "Het shirt heeft geen nieuwe QR nodig.",
        "Jij verandert wat de QR onthult.",
      ],
      ownershipTitle: "OWNERSHIP · LEGACY",
      ownership: [
        "Het shirt behoudt zijn unieke identiteit.",
        "Het fysieke nummer blijft hetzelfde.",
        "Het shirt kan van eigenaar wisselen.",
        "Nieuwe eigenaar → eigen QR Profiel.",
        "Zelfde uniek shirt → een nieuw verhaal.",
      ],
    },
    // 05 · CONNECTED — See → Notice → Scan → Discover → Connect + launch concept
    connected: {
      number: "05 / CONNECTED",
      eyebrow: "WORDEN VERANDERT IN BETEKENIS",
      title: "Van zien tot verbinden — in vijf stappen.",
      steps: [
        { title: "ZIE HET WOORD", body: "Iemand loopt voorbij. Een woord springt in het oog." },
        { title: "MERK HET NUMMER & DE QR", body: "1 van 100. Een specifiek exemplaar." },
        { title: "SCAN", body: "Eén beweging. De QR opent." },
        { title: "ONTDEK", body: "Wat de eigenaar koos te delen — nu." },
        { title: "VERBIND", body: "Persoon, bedrijf, muziek, event, shop, verhaal, ervaring." },
      ],
      possibilitiesLabel: "CONNECTIE-MOGELIJKHEDEN",
      possibilities: [
        "Verbind met een persoon",
        "Verbind met een bedrijf",
        "Verbind met muziek",
        "Verbind met een event",
        "Verbind met een shop",
        "Verbind met een verhaal",
        "Verbind met een ervaring",
      ],
      futureLabel: "FUTURE · EXPERIENCE LAYER",
      future: ["Clues", "Challenges", "Rewards", "Events", "Connected Words games"],
      launchConcept: "6 WOORDEN · 6 MENSEN · 6 SCANS · 6 CODES · SAMEN VORMEN WE WOORDEN TOT BETEKENIS",
    },
    // 06 · PHYSICAL PRODUCT — premium tee + word + number + QR + certificate + packaging
    physical: {
      number: "06 / PHYSICAL PRODUCT",
      eyebrow: "CERTIFICATE OF AUTHENTICITY",
      title: "Een echt papieren certificaat. Voor een tijdloos digitaal shirt.",
      body:
        "Elk Connected Words-shirt komt met een genummerd Certificate of Authenticity op zwaar Clairefontaine Trophée Ivoor 120gr papier, afgewerkt met een blinde 3D-embosstempel en een unieke QR-code die je koppelt aan jouw 1iD-identiteit.",
      specimenNote: "Watermerk toegevoegd — dit is een specimen. Het originele exemplaar is niet online reproduceerbaar.",
      componentsLabel: "IN DE DOOS",
      components: [
        "Premium T-shirt",
        "Connected Word op het shirt",
        "Individueel nummer",
        "Individuele QR",
        "Certificate of Authenticity",
        "Limited Edition packaging",
      ],
      transferTitle: "Overdraagbaar via 1iD",
      transferBody:
        "Een Connected Words-shirt is een collectible met een identiteit. Wanneer je 'm doorgeeft, cadeau doet of doorverkoopt, kan je via 1iD MyProducts het eigenaarschap officieel overdragen naar de nieuwe eigenaar. Het serienummer blijft, het verhaal krijgt een nieuw hoofdstuk.",
      coreIdea:
        "De digitale ervaring vervangt het shirt niet. Ze maakt het fysieke shirt méér dan een T-shirt.",
    },
    // 07 · LAUNCH / FOMO — 01 sep 2026 + CTA
    launch: {
      number: "07 / LAUNCH · FOMO",
      launchLabel: "LANCERING",
      launchDate: "01 · SEP · 2026",
      title: "1e Editie. Zes woorden. 100 stuks per woord. Nooit meer.",
      body:
        "1e Editie met een harde limiet. Ze worden niet bijgedrukt. Ze worden niet uitgebreid. Wie te laat is, mist het.",
      facts: ["1e EDITIE", "6 WOORDEN", "SLECHTS 100 PER WOORD", "INDIVIDUEEL GENUMMERD", "GEEN HERDRUK"],
      ctaTitle: "JOUW ZET",
      ctaSteps: ["Kies jouw woord", "Kies jouw maat", "Krijg jouw nummer", "Bestel voor jouw woord weg is"],
      caption: "Registratie, checkout, betaling en QR-personalisatie verlopen volledig binnen 1iD.",
    },
    // 08 · THE MAGIC BEHIND IT — powered by 1iD
    magic: {
      number: "08 / THE MAGIC BEHIND IT",
      eyebrow: "POWERED BY 1iD",
      title: "1iD is niet het verkoopverhaal. 1iD maakt het verkoopverhaal mogelijk.",
      body:
        "1iD is geen platform dat je gebruikt — het is een digitale identiteit die je bezit. Geen advertenties, geen tracking, geen verlopen links. Privacy is geen feature. Het is het uitgangspunt.",
      bullets: [
        "Verbindt het fysieke shirt met zijn identiteit",
        "Voedt het configureerbare QR Profiel",
        "Houdt product-identiteit en eigenaar/profiel gescheiden",
        "Maakt profielwijzigingen mogelijk",
        "Ondersteunt gecontroleerd delen",
        "Ondersteunt authenticiteit",
        "Maakt eigenaarschap mogelijk over de volledige levensduur",
      ],
      rulesLabel: "POSITIONING RULE",
      rules: ["1iD IS NIET HET VERKOOPVERHAAL.", "1iD MAAKT HET VERKOOPVERHAAL MOGELIJK."],
    },
    // Persona sub-block (blijft binnen 08 MAGIC)
    personas: {
      title: "Drie eigenaars. Drie keuzes.",
      sub: "Één principe: jij beslist wat de wereld ziet wanneer iemand jouw QR scant.",
      cardStatus: "UNDER CONSTRUCTION",
      cardCaption: "1iD MyProducts lanceert samen met de drop.",
      simulate: "Simuleer scan",
      list: [
        {
          name: "Danny",
          type: "Business",
          tagline: "Deelt zijn LinkedIn, bedrijf en website.",
          serial: "E1-1/100",
          qr: PERSONA_QRS.danny,
          url: "https://use1id.com/demo-e1.w1.1.100.html",
        },
        {
          name: "Mia",
          type: "Entertainment",
          tagline: "Deelt haar Spotify, TikTok en favoriete bar.",
          serial: "E1-2/100",
          qr: PERSONA_QRS.mia,
          url: "https://use1id.com/demo-e1.w1.2.100.html",
        },
        {
          name: "Vera",
          type: "Private",
          tagline: "Deelt alleen wat zij vandaag zelf wil.",
          serial: "E1-3/100",
          qr: PERSONA_QRS.vera,
          url: "https://use1id.com/demo-e1.w1.3.100.html",
        },
      ],
    },
    marquee: "EENMALIGE RELEASE · 1e EDITIE",
    words: [
      {
        word: "TOGETHER",
        meaning:
          "We bestaan niet alleen. Alles begint met de keuze om naast iemand te gaan staan. Samen maken we de zin compleet.",
      },
      {
        word: "WE",
        meaning:
          "Een grotere ik. Een gedeelde identiteit die het individu niet uitwist maar vermenigvuldigt.",
      },
      {
        word: "TURN",
        meaning:
          "Beweging. De beslissing om iets te doen. Een stilstaand moment ombuigen naar actie.",
      },
      { word: "WORDS", meaning: "Grondstof. Lege klankschelpen tot iemand ze vult met bedoeling." },
      {
        word: "INTO",
        meaning:
          "Een brug. Het kleine woord dat alles draagt van de ene kant van een idee naar de andere.",
      },
      { word: "MEANING", meaning: "Niet iets dat je vindt — iets dat je maakt, samen, met opzet." },
    ],
    wordIndex: (i, total) => `Woord ${String(i).padStart(2, "0")} / ${String(total).padStart(2, "0")}`,
    serialOf: (n) => `E1-${n}/100`,
    perWord: "100 unieke eigenaars per woord",
    footer: {
      tagline: "Connected Words — 1e Editie",
      rights: "Alle rechten voorbehouden.",
      contact: "Contact",
      privacy: "Privacy",
      terms: "Voorwaarden",
    },
  },

  en: {
    nav: {
      limited: "LIMITED",
      unique: "UNIQUE",
      story: "YOUR STORY",
      connected: "CONNECTED",
      launch: "1st EDITION",
      magic: "1iD",
    },
    cta: {
      reserveTop: "ORDER NOW VIA 1iD",
      reserveHero: "ORDER NOW VIA 1iD",
      readConcept: "DISCOVER THE CONCEPT",
      reserveOn1iD: "Order now via 1iD",
    },
    breadcrumb: {
      edition: "1st EDITION",
      title: "CONNECTED WORDS",
      drop: "6 × 100",
      live: "LIVE",
    },
    sideLabel: "6 WORDS · LIMITED TO 100 SHIRTS OF EACH WORD",
    editionLabel: "1st Edition",
    preorder: {
      eyebrow: "1st EDITION · LAUNCH 01 SEP 2026",
      title: "Not a t-shirt.",
      titleAccent: "A living identity.",
      lines: [
        "6 words. 600 shirts. Never reprinted.",
        "Every shirt carries a unique number and a unique QR.",
        "You decide what the world sees when someone scans.",
      ],
      metaLeft: "1st EDITION",
      metaRight: "6 × 100",
      cta: "ORDER NOW VIA 1iD",
      note: "Registration, checkout, payment and QR personalisation all happen inside 1iD.",
      close: "Close",
      // Temporary voucher variant (active until 30-sep-2026 EOD)
      discountLines: [
        "Claim your 30% discount voucher via the link below.",
        "The voucher is limited in time and quantity, so be quick.",
      ],
      discountCta: "CLAIM YOUR VOUCHER NOW",
      discountUrl:
        "https://use1id-prd.vercel.app/r/logon?discount_grant_token=c5e8e2ca-5e2f-45c9-a506-42b43ca804fe&next=%2Fr%2FMy-1iD-Products%3Fdiscount_grant_token%3Dc5e8e2ca-5e2f-45c9-a506-42b43ca804fe",
    },
    // Launch event popup — active until 5 sept 2026 10:00 CET
    launchEvent: {
      eyebrow: "5 SEP 2026 · TIENEN",
      title: "Win your",
      titleAccent: "Connected Words T-shirt",
      when: "Saturday 5 September · 10:10 – 12:10 · Tienen",
      intro:
        "The 1st Limited Edition of Connected Words launches. Find the six words, connect with the participating Tienen shops and collect points.",
      sentence: "TOGETHER · WE · TURN · WORDS · INTO · MEANING",
      journey: "SEARCH → SCAN → ANSWER → COLLECT",
      mechanic:
        "The more points, the bigger your discount — up to 100 points = a free T-shirt.",
      warningLabel: "HEADS UP",
      warning:
        "Only 6 discount vouchers can be redeemed. The first 6 buyers win. A high score alone is not enough — speed of redemption counts too.",
      howLabel: "HOW IT WORKS",
      how: [
        'Before the start the "CW Launch Page" button becomes active (currently disabled).',
        'At 10:10 "Start Journey" becomes active — click it and the game begins.',
        "The tasks guide you step by step past the shops and questions.",
        "Where exactly do you end up? You only find out along the way.",
        "At 12:10 the game closes.",
      ],
      prepareLabel: "GET READY",
      prepare: [
        "Create your free 1iD account in advance.",
        "Test that your QR scanner works — try it on the 3 demo codes on this website.",
        "Follow the Connected Words website, Facebook and Instagram for the link.",
      ],
      uniqueLabel: "WHAT MAKES THIS SHIRT UNIQUE?",
      unique:
        "Every T-shirt from the 1st Limited Edition is certified, limited, unique: its own word, unique number, unique QR code, own owner. Through 1iD you decide what appears when someone scans your code — and you can change it later.",
      taglineLine1: "YOUR SHIRT. YOUR QR CODE. YOUR STORY.",
      taglineLine2: "TOGETHER WE TURN WORDS INTO MEANING.",
      launchBtn: "CW LAUNCH PAGE",
      launchBtnDisabledHint: "(currently disabled)",
      registerBtn: "PLAY VIA THIS LINK",
      registerUrl: "https://use1id-prd.vercel.app/r/register?next=",
      close: "Close",
    },
    showcase: {
      eyebrow: "NOT JUST A T-SHIRT.",
      title: "A unique 1iD.",
      titleAccent: "A living identity.",
      sub: "SCAN IT. CONNECT. FOLLOW. CONFIGURE.",
      tagline: "WORDS CONNECT. IDENTITY LASTS.",
      steps: [
        {
          index: "01",
          title: "CREATED TO BE UNIQUE",
          body: "Each shirt is part of a limited edition. Only 100 pieces per word — worldwide.",
        },
        {
          index: "02",
          title: "SCAN TO CONNECT",
          body: "Instant access to a living, digital identity — the owner's.",
        },
        {
          index: "03",
          title: "CONFIGURE & MANAGE",
          body: "You are in control. Always. Change what the world sees — whenever you want.",
        },
      ],
      manageActions: [
        "Update content",
        "Add items",
        "Change visibility",
        "Control sharing",
        "You decide what is shown and to whom",
      ],
      pillars: [
        { label: "IDENTITY", body: "Your digital identity — in one scan." },
        { label: "AUTHENTICITY", body: "100% verified. 100% unique." },
        { label: "CONNECTION", body: "Connect with people, projects & purpose." },
        { label: "STORY", body: "Share your journey. Your way." },
        { label: "LEGACY", body: "A piece today. A story forever." },
        { label: "PRIVACY FIRST", body: "You always stay in control." },
      ],
      cta: "ORDER NOW VIA 1iD",
      profileCard: {
        badge: "BUSINESS · IDENTITY CARD",
        name: "Danny Vandijck",
        role: "Founder · Business Optimization, Coach, Change Manager",
        message: "Available for projects from 01-SEP-2026. Reach me through my website.",
        links: ["Website · dv-mc.com", "LinkedIn · dannyvandijck", "Instagram · use1id", "Connected Words shop"],
        footer: "QR profile powered by 1iD · Your product. Your identity.",
      },
    },
    hero: {
      eyebrow: "MORE THAN JUST A T-SHIRT",
      headlineParts: ["Together", " we ", "turn", " words ", "into meaning."],
      sub: "Your shirt. Your QR code. Your story.",
      intro:
        "Six words. Only 100 unique shirts per word. No reprints. No second edition. Every shirt features a unique QR code that you control through 1iD.",
      stats: {
        edition: "Edition",
        editionValue: "E1",
        words: "Words",
        wordsValue: "6 × 100",
        reprint: "Reprint",
        reprintValue: "Never",
      },
    },
    limited: {
      number: "01 / LIMITED",
      eyebrow: "1st EDITION · 6 × 100",
      title: "A limited first edition. No second chance.",
      body:
        "6 words. 100 shirts per word. 600 pieces in total. Once a word is sold out, it is gone. Edition 1 remains Edition 1 — no reprint, no alternative run. Miss it and it's gone.",
      stats: [
        { label: "Edition", value: "E1" },
        { label: "Words", value: "6" },
        { label: "Per word", value: "100" },
        { label: "Reprint", value: "Never" },
      ],
      whyItMatters: "WHY IT MATTERS",
      reasons: [
        "Once a word is sold out, it is gone.",
        "Edition 1 remains Edition 1 — no reprint.",
        "You own a specific piece of the edition.",
      ],
    },
    collection: {
      number: "01 · THE COLLECTION",
      title: "Six words. Six worlds. 100 unique owners per word.",
      hint: "Hover or tap to read its meaning. Each word exists only 100 times.",
    },
    unique: {
      number: "02 / UNIQUE",
      title: "Your number. Your QR. Your profile.",
      body:
        "Every shirt is individually numbered (1/100 → 100/100) and carries its own QR code. The QR is not a fixed link — it is connected to a profile you choose and change. Your exact shirt exists only once.",
      pillars: [
        {
          label: "YOUR NUMBER",
          items: [
            "Every shirt individually numbered",
            "1/100 → 100/100",
            "example: E1 · TOGETHER · 017/100",
            "Your exact shirt exists only once",
          ],
        },
        {
          label: "YOUR QR",
          items: [
            "Every shirt has its own QR",
            "Scan the shirt",
            "QR connects physical shirt to digital experience",
            "Not simply a fixed link printed on a shirt",
          ],
        },
        {
          label: "YOUR PROFILE",
          items: [
            "You choose the QR Profile",
            "Configure your content",
            "Change what is visible",
            "Privacy first — you stay in control",
          ],
        },
      ],
      authenticityLabel: "AUTHENTICITY",
      authenticity: [
        "Unique product identity",
        "Certificate of Authenticity",
        "Edition · Word · Unique number",
        "QR connected to that exact shirt",
      ],
    },
    story: {
      number: "03 / YOUR STORY",
      eyebrow: "WHAT CAN YOUR SHIRT REVEAL?",
      title: "What can your shirt reveal?",
      body:
        "Business. Music. Sport. Social. Events. Shop. You. They scan. You decide what they discover.",
      categories: [
        {
          key: "BUSINESS",
          items: ["Business card", "Company", "Website", "LinkedIn", "Portfolio / CV", "Contact"],
        },
        {
          key: "MUSIC",
          items: ["Artist / band profile", "Spotify", "Songs", "Performances", "Upcoming dates", "Music story"],
        },
        {
          key: "SPORT",
          items: ["Athlete profile", "Club", "Results", "Palmares", "Sponsors", "Upcoming events"],
        },
        {
          key: "SOCIAL / CREATOR",
          items: ["TikTok", "Instagram", "Social profiles", "Latest content", "Collaborations"],
        },
        {
          key: "EVENTS",
          items: ["Event information", "Dates", "Location", "Programme", "Special experience / game / clue"],
        },
        {
          key: "SHOP",
          items: ["Webshop", "Products", "New releases", "Offers"],
        },
        {
          key: "YOU",
          items: ["Personal message", "Photos", "Memories", "Interests", "Causes / projects", "Whatever matters to you"],
        },
      ],
      coreLine1: "THEY SCAN.",
      coreLine2: "YOU DECIDE WHAT THEY DISCOVER.",
    },
    living: {
      number: "04 / LIVING",
      eyebrow: "SAME SHIRT. NEW STORY.",
      title: "Same shirt. New story.",
      body:
        "Your life changes. Your interests change. Your work changes. Your events change. Your content changes. Your QR Profile can change with you.",
      pivots: [
        { label: "TODAY", body: "Business profile" },
        { label: "TONIGHT", body: "Music / event profile" },
        { label: "TOMORROW", body: "Something completely different" },
      ],
      coreIdea: [
        "The shirt doesn't need a new QR.",
        "You change what the QR reveals.",
      ],
      ownershipTitle: "OWNERSHIP · LEGACY",
      ownership: [
        "The shirt keeps its unique identity.",
        "The physical number remains the same.",
        "The shirt can change owner.",
        "New owner → own QR Profile.",
        "Same unique shirt → a new story continues.",
      ],
    },
    connected: {
      number: "05 / CONNECTED",
      eyebrow: "WORDS TURN INTO MEANING",
      title: "From see to connect — in five steps.",
      steps: [
        { title: "SEE THE WORD", body: "Someone walks by. A word catches the eye." },
        { title: "NOTICE THE NUMBER & QR", body: "One of one hundred. A specific piece." },
        { title: "SCAN", body: "One motion. The QR opens." },
        { title: "DISCOVER", body: "What the owner chose to share — right now." },
        { title: "CONNECT", body: "Person, business, music, event, shop, story, experience." },
      ],
      possibilitiesLabel: "CONNECTION POSSIBILITIES",
      possibilities: [
        "Connect with a person",
        "Connect with a business",
        "Connect with music",
        "Connect with an event",
        "Connect with a shop",
        "Connect with a story",
        "Connect with an experience",
      ],
      futureLabel: "FUTURE · EXPERIENCE LAYER",
      future: ["Clues", "Challenges", "Rewards", "Events", "Connected Words games"],
      launchConcept: "6 WORDS · 6 PEOPLE · 6 SCANS · 6 CODES · TOGETHER WE TURN WORDS INTO MEANING",
    },
    physical: {
      number: "06 / PHYSICAL PRODUCT",
      eyebrow: "CERTIFICATE OF AUTHENTICITY",
      title: "A real paper certificate. For a timeless digital shirt.",
      body:
        "Every Connected Words shirt comes with a numbered Certificate of Authenticity on heavy Clairefontaine Trophée Ivory 120gr paper, finished with a blind 3D emboss stamp and a unique QR code linking to your 1iD identity.",
      specimenNote: "Watermark added — this is a specimen. The original is not reproducible online.",
      componentsLabel: "IN THE BOX",
      components: [
        "Premium T-shirt",
        "Connected Word on the shirt",
        "Individual number",
        "Individual QR",
        "Certificate of Authenticity",
        "Limited Edition packaging",
      ],
      transferTitle: "Transferable via 1iD",
      transferBody:
        "A Connected Words shirt is a collectible with an identity. If you ever pass it on, gift it or resell it, you can officially transfer ownership to the new owner through 1iD MyProducts. The serial stays. The story gets a new chapter.",
      coreIdea:
        "The digital experience does not replace the shirt. It makes the physical shirt more than a t-shirt.",
    },
    launch: {
      number: "07 / LAUNCH · FOMO",
      launchLabel: "LAUNCH",
      launchDate: "01 · SEP · 2026",
      title: "1st Edition. Six words. 100 pieces per word. Never again.",
      body:
        "1st Edition is a hard limit. They will not be reprinted. They will not be extended. Miss it and it's gone.",
      facts: ["1st EDITION", "6 WORDS", "ONLY 100 OF EACH", "INDIVIDUALLY NUMBERED", "NO REPRINT"],
      ctaTitle: "YOUR MOVE",
      ctaSteps: ["Choose your word", "Choose your size", "Get your number", "Get yours before your word is gone"],
      caption: "Registration, checkout, payment and QR personalisation all happen inside 1iD.",
    },
    magic: {
      number: "08 / THE MAGIC BEHIND IT",
      eyebrow: "POWERED BY 1iD",
      title: "1iD is not the sales story. 1iD makes the sales story possible.",
      body:
        "1iD is not a platform you use — it is a digital identity you own. No ads, no tracking, no expiring links. Privacy is not a feature. It is the starting point.",
      bullets: [
        "Connects the physical shirt with its identity",
        "Powers the configurable QR Profile",
        "Keeps product identity and owner/profile separate",
        "Enables profile changes",
        "Enables controlled sharing",
        "Supports authenticity",
        "Enables ownership over the shirt's lifetime",
      ],
      rulesLabel: "POSITIONING RULE",
      rules: ["1iD IS NOT THE SALES STORY.", "1iD MAKES THE SALES STORY POSSIBLE."],
    },
    personas: {
      title: "Three owners. Three choices.",
      sub: "One principle: you decide what the world sees when someone scans your QR.",
      cardStatus: "UNDER CONSTRUCTION",
      cardCaption: "1iD MyProducts launches together with the drop.",
      simulate: "Simulate scan",
      list: [
        {
          name: "Danny",
          type: "Business",
          tagline: "Shares his LinkedIn, company and website.",
          serial: "E1-1/100",
          qr: PERSONA_QRS.danny,
          url: "https://use1id.com/demo-e1.w1.1.100.html",
        },
        {
          name: "Mia",
          type: "Entertainment",
          tagline: "Shares her Spotify, TikTok and favourite bar.",
          serial: "E1-2/100",
          qr: PERSONA_QRS.mia,
          url: "https://use1id.com/demo-e1.w1.2.100.html",
        },
        {
          name: "Vera",
          type: "Private",
          tagline: "Shares only what she chooses to, today.",
          serial: "E1-3/100",
          qr: PERSONA_QRS.vera,
          url: "https://use1id.com/demo-e1.w1.3.100.html",
        },
      ],
    },
    marquee: "ONE-TIME RELEASE · 1st EDITION",
    words: [
      {
        word: "TOGETHER",
        meaning:
          "We do not exist alone. Everything begins with the choice to stand next to someone. Together we complete the sentence.",
      },
      {
        word: "WE",
        meaning:
          "A bigger I. A shared identity that does not erase the individual but multiplies them.",
      },
      {
        word: "TURN",
        meaning:
          "Movement. The decision to do something. Bending a still moment into action.",
      },
      {
        word: "WORDS",
        meaning:
          "Raw material. Empty shells of sound until someone fills them with intent.",
      },
      {
        word: "INTO",
        meaning:
          "A bridge. The small word that carries everything from one side of an idea to the other.",
      },
      {
        word: "MEANING",
        meaning:
          "Not something you find — something you make, together, on purpose.",
      },
    ],
    wordIndex: (i, total) => `Word ${String(i).padStart(2, "0")} / ${String(total).padStart(2, "0")}`,
    serialOf: (n) => `E1-${n}/100`,
    perWord: "100 unique owners per word",
    footer: {
      tagline: "Connected Words — 1st Edition",
      rights: "All rights reserved.",
      contact: "Contact",
      privacy: "Privacy",
      terms: "Terms",
    },
  },
};

// SVG logo (transparent) — preferred. PNG kept as fallback.
export const cwLogo = "/cw-logo.svg";
export const cwLogoPng =
  "https://customer-assets.emergentagent.com/job_word-shirt-qr-1/artifacts/opmcmwfe_logo.png";

const _shirtOriginals = [
  "https://customer-assets.emergentagent.com/job_word-shirt-qr/artifacts/k6srakx0_E1-W1-1.png",
  "https://customer-assets.emergentagent.com/job_word-shirt-qr/artifacts/cryj8emv_E1-W2-1.png",
  "https://customer-assets.emergentagent.com/job_word-shirt-qr/artifacts/5dedv3j7_E1-W3-1.png",
  "https://customer-assets.emergentagent.com/job_word-shirt-qr/artifacts/dfjedo87_E1-W4-1.png",
  "https://customer-assets.emergentagent.com/job_word-shirt-qr/artifacts/og3kq4vg_E1-W5-1.png",
  "https://customer-assets.emergentagent.com/job_word-shirt-qr-1/artifacts/1x8apdks_E1-W6-1.png",
];

export const shirtImages = _shirtOriginals.map((u) => optim(u, 900));

export const shirtBack = optim(
  "https://customer-assets.emergentagent.com/job_word-shirt-qr-1/artifacts/rd3uioka_E1-W1-2.png",
  900,
);

// Certificate of Authenticity photo — proxied through wsrv.nl (also strips EXIF).
export const certificateImage = optim(
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_word-shirt-qr-1/artifacts/tjkcjb79_image.png",
  1100,
);

// Showcase mockups — provided as-is by user (visuele elementen van 1iD demo).
// Gebruikt in SectionMarketing (col 2 = events profile in phone frame, col 3 = admin screen).
export const showcaseEventsProfile = optim(
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_word-shirt-qr-1/artifacts/b595o97e_image.png",
  600,
);

export const showcaseAdminScreen = optim(
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_word-shirt-qr-1/artifacts/nocsr6u5_image.png",
  900,
);
